import type { WidgetEffectParams } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';
import getErrorStatusCode from '@swf/sports/utils/getErrorStatusCode';

import type { AntePostEventsHandlerResponseBody, WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(
    _payload: undefined,
    { dispatch, select, widget, rootState }: WidgetEffectParams<BasicSportsWidgetConfig>
  ) {
    const { antePostEventsRequested, clear }: WidgetDispatch = dispatch[widget.uid];
    const widgetSelect: WidgetSelect = select[widget.uid];

    widget.unmount.subscribe(clear);

    const hasPreloaded = widgetSelect.hasPreloaded(rootState);
    if (!hasPreloaded) {
      await antePostEventsRequested();
    }
  },
  async antePostEventsRequested(
    _payload: undefined,
    { dispatch, request, widget, select, rootState }: WidgetEffectParams<BasicSportsWidgetConfig>
  ): Promise<void> {
    const sportsRequest = buildSportsRequest(request, rootState);
    const { eventTypeId } = select.sports.getUrlParams(rootState);

    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];
    try {
      const { body } = await sportsRequest<AntePostEventsHandlerResponseBody>({
        path: `/ante-post-events/${eventTypeId}`
      });

      widgetDispatch.dataLoadSuccess(body);
    } catch (error) {
      widgetDispatch.dataLoadFailed(getErrorStatusCode(error));
    }
  }
};
